import * as session from 'smg/customer-api/session';

import { AccountReady } from '../account-session';
import { Relref } from '../hugo';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    const sess = await session.Session();

    // Populate sidebar user identity
    const $userName = document.querySelector('#sidebar-user-name');
    const $userEmail = document.querySelector('#sidebar-user-email');
    if ($userName) {
        $userName.textContent = [sess.user.firstName, sess.user.lastName].filter(Boolean).join(' ') || (sess.user.emailAddress.email ?? '');
    }
    if ($userEmail) {
        $userEmail.textContent = sess.user.emailAddress.email ?? '';
    }

    // Sign out
    const $signOut = document.querySelector('#sign-out');
    $signOut?.addEventListener('click', () => {
        session.DeleteSession();
        window.location.href = Relref('/login');
    });
}
